import { TFunction } from "i18next";

import type { Order } from "../../../../../../../services";
import type { ColorState } from "../../../../../../../redux/reducers/settings/colors";
import {
	getOrderPaymentStatus,
	paymentStatusColorKey,
	paymentStatusTextColor,
} from "../../../../../../../utils/orderPaymentStatus";

/** Text and fill of the "Payment status" cell: the status color from settings. */
const cellProcessing = (
	item?: Order.Model,
	t?: TFunction,
	colors?: ColorState,
): { content: string; backgroundColor?: string; textColor?: string } => {
	const status = getOrderPaymentStatus(item);
	if (!item || !t || !status) {
		return { content: "" };
	}

	const backgroundColor = colors?.[paymentStatusColorKey(status)];

	return {
		content: t(`order_payment_status.${status}`) ?? "",
		backgroundColor,
		textColor: paymentStatusTextColor(backgroundColor),
	};
};

export default cellProcessing;
